module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-defaultImage"
  }, [_c('div', {
    staticClass: "image-content",
    class: _vm.classes
  }, [_vm._t("default", [_c('rt-icon', {
    attrs: {
      "size": _vm.iconSize,
      "name": "rt-base-default_image"
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_vm._t("describe", [_vm._v("\n      啊哦！暂时搜索不到您要的内容哦！\n    ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbbdd558"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/defaultImage/rtDefaultImage.vue
// module id = 1543
// module chunks = 72